/**
 * ESCHER FALLS — 共有の口。`ios/App/App/SharePlugin.swift` の薄い包み。
 *
 * **使えない場所では口そのものを出さない。** ブラウザやプラグインの無い環境で
 * 押せないボタンを並べても、押せなかった人が困るだけである
 * （売り場と同じ規則：`iap.ts` 規則1）。
 */

import { Capacitor, registerPlugin } from '@capacitor/core';

interface ShareNative {
  share(options: { text: string; png: string }): Promise<{ shared: boolean }>;
}

const ShareCard = registerPlugin<ShareNative>('ShareCard');

/** 共有できる場所か。ボタンを出すかどうかの判定に使う。 */
export function isShareAvailable(): boolean {
  return Capacitor.isNativePlatform();
}

/**
 * 一枚を送る。送れたら true。**失敗しても投げない。**
 *
 * 送信面（どのアプリへ送るか）は OS が出す。こちらは中身を渡すだけで、
 * どこへ行ったかは知らないし、知る必要もない。
 */
export async function shareCard(text: string, png: string): Promise<boolean> {
  if (!isShareAvailable()) return false;
  try {
    const r = await ShareCard.share({ text, png });
    return r.shared === true;
  } catch {
    return false;
  }
}
